import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 12h13M12 5l7 7-7 7" })
});
export default SvgRightArrow;
